import Navbar from './components/Navbar';
import DonationForm from './components/DonationForm';
import NewsletterForm from './components/NewsletterForm';

import '@fancyapps/fancybox';
import AOS from 'aos';

let navbar = document.querySelector('nav');
let donationForm = document.querySelector('.donation-form-container');

if (navbar) {
  Navbar();
}

if (donationForm) {
  DonationForm();
}

{
  let newsletter = document.querySelector('[data-newsletter-banner]');
  if ( typeof newsletter != 'undefined' && newsletter ) {
    NewsletterForm(newsletter);
  }
}

AOS.init();


// WEBPACK FOOTER //
// ./src/js/app/index.js